import { type VariantProps, cva } from 'class-variance-authority';

import s from './Toast.module.css';

export const toastVariants = cva(s.toast, {
  compoundVariants: [
    {
      className: s.defaultWithAction,
      type: 'default',
      withAction: true,
    },
    {
      className: s.infoWithAction,
      type: 'info',
      withAction: true,
    },
    {
      className: s.successWithAction,
      type: 'success',
      withAction: true,
    },
    {
      className: s.warningWithAction,
      type: 'warning',
      withAction: true,
    },
    {
      className: s.errorWithAction,
      type: 'error',
      withAction: true,
    },
  ],
  defaultVariants: {
    type: 'default',
    withAction: false,
  },
  variants: {
    type: {
      default: s.default,
      error: s.error,
      info: s.info,
      success: s.success,
      warning: s.warning,
    },
    withAction: {
      true: s.withAction,
    },
  },
});

export type ToastVariant = VariantProps<typeof toastVariants>;
